import React, {useEffect, useState} from 'react';
import {
  Collapse,
} from 'reactstrap'

const Criterion = props => {
  const [isOpen, setIsOpen] = useState(false)
  const [countChecked, setCountChecked] = useState(0)

  let value = props.value
  let onChange = props.onChange
  const title = props.title
  const {name} = props

  useEffect(() => {
    let valueCount = value.reduce((prev, curr) => {
      return prev + curr.value ? 1 : 0
    }, 0)
    setCountChecked(valueCount)
  }, [value])

  function attributeOnChange (e) {
    const key = e.target.value
    const checked = e.target.checked
    value[key].value = checked
    onChange(name, value)
    let valueCount = value.reduce((prev, curr) => {
      return prev + (curr.value ? 1 : 0)
    }, 0)
    setCountChecked(valueCount)
  }

  if (!value) {
    return (<p/>)
  }

  const valueCount = countChecked ? countChecked : ''

  return (
    <div>
      <span style={{marginLeft: '10px', fontSize: '20px'}} onClick={() => {setIsOpen(!isOpen)}}>
        {valueCount !== '' && <><strong>{title}&nbsp;{isOpen ? '-' : '+'}</strong><sup>{valueCount}</sup></> }
        {valueCount === '' && <>{title}&nbsp;{isOpen ? '-' : '+'}</> }
      </span>
      <Collapse isOpen={isOpen}>
        {
          value.map(({key, value, title}, index) => {
            return (
              <div style={{marginLeft: '1em'}} key={key}>
                <input type="checkBox"
                  value={index}
                  checked={value}
                  onChange={attributeOnChange}
                  />
                  &nbsp;{title ? title : key}
              </div>
            )
          })
        }
      </Collapse>
    </div>
  )
}

export default Criterion
